import React from 'react';

import { QuestionString, QuestionTypeV2 } from '../../../redux/types';
import TextQuestionEditor from '../TextQuestionEditor';

export type Props = {
  surveyId: number;
  sectionId?: number;
  question?: QuestionString;
  addQuestion?: (dq: Omit<QuestionString, 'id'>) => void
  updateQuestion?: (dq: QuestionString) => void
  onCancelEdit?: () => void;
  disableHideAggregation?: boolean;
}

const StringQuestionEditor: React.FC<Props> = ({
  surveyId,
  sectionId,
  question,
  addQuestion,
  updateQuestion,
  onCancelEdit,
  disableHideAggregation,
}: Props) => (
  <TextQuestionEditor<QuestionString>
    type={QuestionTypeV2.String}
    surveyId={surveyId}
    sectionId={sectionId}
    question={question}
    addQuestion={addQuestion}
    updateQuestion={updateQuestion}
    onCancelEdit={onCancelEdit}
    disableHideAggregation={disableHideAggregation}
  />
);

export default StringQuestionEditor;
